import { ColorScheme } from '@app-types/general'

// These are the hardcoded color schemes that are available to the user in Timetoast Unbound
// The user can choose between these color schemes to change the appearance of the views
// Note: Color schemes with an id will be DB-driven in the future

// Primary Color:
// Dominance: 50-60%
// Usage: This is the main color of your theme, used for major elements like the header, footer, and primary buttons. It sets the overall tone of the page.
//
// Secondary Color:
// Dominance: 20-30%
// Usage: This color is used for elements that support the primary color, such as subheadings, links, and secondary buttons. It helps to create a visual hierarchy.
//
// Tertiary Color:
// Dominance: 10-15%
// Usage: This color is used for accents and less prominent elements like borders, backgrounds of sidebars, or block quotes. It adds depth and subtle variation.
//
// Highlight Color:
// Dominance: 5-10%
// Usage: This color is used sparingly to draw attention to specific elements like important quotes, key points, or call-to-action sections. It is meant to stand out.

// Type for the keys of COLOR_SCHEMES
export type ColorSchemeKey = 'null' | number

export const COLOR_SCHEMES: Record<ColorSchemeKey, ColorScheme> = {
  // the default color scheme, this is subject to change whenever the site is redesigned
  // If the default is chosen, its value is null
  null: {
    primary: '#F3F3F3',
    secondary: '#FFFFFF',
    tertiary: '#808080',
    highlight: '#5A00FF',
  },
  // light breeze
  1: {
    primary: '#F3F3F3',
    secondary: '#FFFFFF',
    tertiary: '#A3A3A3',
    highlight: '#1E40AF',
  },
  // soft meadow
  2: {
    primary: '#F7FFF7',
    secondary: '#FFFFFF',
    tertiary: '#8CA08C',
    highlight: '#009E60',
  },
  // gentle sunset
  3: {
    primary: '#FFF7F0',
    secondary: '#FFFFFF',
    tertiary: '#CFA07D',
    highlight: '#FF5722',
  },
  // sky mist
  4: {
    primary: '#E8F4FA',
    secondary: '#FFFFFF',
    tertiary: '#B0BEC5',
    highlight: '#0288D1',
  },
  // calm lavender
  5: {
    primary: '#F4F0F8',
    secondary: '#FFFFFF',
    tertiary: '#B1AFC6',
    highlight: '#6A1B9A',
  },
  // warm sand
  6: {
    primary: '#FAF5E4',
    secondary: '#FFFFFF',
    tertiary: '#C9B89F',
    highlight: '#FF8C42',
  },
}

export const DARK_TEXT_COLOR: string = '#3f3f42'
export const LIGHT_TEXT_COLOR: string = '#FFFFFF'
